import { render } from "./SubPrices.vue?vue&type=template&id=542d4b0a&scoped=true"
import script from "./SubPrices.vue?vue&type=script&lang=js"
export * from "./SubPrices.vue?vue&type=script&lang=js"

import "./SubPrices.vue?vue&type=style&index=0&id=542d4b0a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542d4b0a"]])

export default __exports__